import type { GetOrders200OrdersItem } from './getOrders200OrdersItem';

export type GetOrders200 = {
  orders: GetOrders200OrdersItem[];
  /** 전체 개수 */
  totalCount: number;
};
